import { useEffect, useRef, useState } from 'react';
import parse from 'html-react-parser';
import { Modal } from 'react-bootstrap';

import { Customer } from '../../classess/customer/customer';
import {
    badgetStatusGeneric, getProcessButtons, checkUrl, handleResponseMessageAsync, isUndNullEmp, isValidEmail, isValidPhoneNumber, isValidUrl, getLanguageObj,
    getResponse, settings, styles
} from '../../helpers/main';
import { GlobalFormats } from '../../classess/main/globalFormats';
import { CustomerService } from '../../services/customers/CustomerService';

const { icons, images, labels, messages, } = settings;

const currentMethod = 'CustomerAddEditDetails';

export default function CustomerAddEditDetails({
    auth = {},
    modalObj = {
        $: {},
        type: 0,
        auth: auth,
        showModal: false,
        languageObj: GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
        dtCustomersId: '',
        dtCustomersRowId: 0,
    },
    setModalObj = {},
    customer = Customer?.getClass({}, false),
    setCustomer = {},
}) {
    //#region variables
    const [errors, setErrors] = useState({
        secondaryId: '',
        name: '',
        rif: '',
        nit: '',
        phones: '',
        fax: '',
        address: '',
        email: '',
        webSite: '',
    });

    const [process, setProcess] = useState({
        showLoading: false,
        save: false,
    });
    const isMount = useRef(true);
    const [dataFormLength] = useState(Customer.minMaxLength(false));
    const controls = {
        buttons: {
            back: {
                defaultClass: 'btn btn-sm btn-outline-success',
                id: 'btnBack',
            },
            save: {
                defaultClass: 'btn btn-sm btn-outline-primary mx-1',
                id: 'btnSave',
            },
            closeModal: {
                defaultClass: 'close btn-danger fas fa-window-close',
                id: 'btnModalClose',
            },
        },
        checkBox: {
            isAvailable: {
                id: 'chkIsAvailable',
            },
        },
        icons: {
            save: {
                id: 'iconSave',
                defaultClass: icons?.fasFa?.save,
            },
            back: {
                id: 'iconBack',
                defaultClass: icons?.fasFa?.arrowCircleLeft,
            },
        },
        inputs: {
            secondaryId: {
                id: 'inputSecondaryId',
            },
            name: {
                id: 'inputName',
            },
            rif: {
                id: 'inputRif',
            },
            nit: {
                id: 'inputNit',
            },
            phones: {
                id: 'inputPhones',
            },
            fax: {
                id: 'inputFax',
            },
            email: {
                id: 'inputEmail',
            },
            webSite: {
                id: 'inputWebSite',
            },
            registerDate: {
                id: 'inputRegisterDate',
            },
        },
        pickers: {
            registerDate: {
                id: 'pkrRegisterDate',
            },
        },
        selects: {
            country: {
                id: 'selCountry'
            },
        },
        spiners: {
            save: {
                id: 'spSave',
                defaultClass: '',
            }
        },
        textAreas: {
            address: {
                id: 'textAreaAddress',
            }
        }
    };
    //#endregion variables

    //#region methods
    //#region customer
    const addCustomer = async ({
        e = undefined,
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'addCustomer';
        try {
            e?.preventDefault?.();

            //#region errors default / validate data
            response = setErrorsDefault({
                subMethod: currentMethod,
            });
            if (!response?.isSuccess || response?.isWarning) return;

            response = validateFormData({
                subMethod: currentMethod,
            });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion errors default / validate data

            setProcess(prev => ({ ...prev, save: true }));

            //#region customer (create)
            response = await CustomerService.create({
                auth: modalObj?.auth,
                data: customer,
                languageId: modalObj?.languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;

            const newCustomer = Customer?.getClass(response?.result.customer, false);
            //#endregion customer (create)

            //#region datatable add
            const processButtons = [];
            modalObj.$(`#${modalObj.dtCustomersId}`).DataTable().row.add([
                newCustomer?.secundaryId,
                newCustomer?.name,
                newCustomer?.rif,
                newCustomer?.nit,
                badgetStatusGeneric({
                    type: newCustomer?.isAvailable ? 0 : 5,
                    value: newCustomer?.isAvailable ? labels?.yes?.[modalObj?.languageObj?.id] : labels?.no?.[modalObj?.languageObj?.id],
                }),
                getProcessButtons({
                    id: newCustomer?.id,
                    description: newCustomer?.name,
                    showDetails: true,
                    labelDetails: labels?.details[modalObj?.languageObj?.id],
                    enabledDetails: true,
                    showDelete: true,
                    labelDelete: labels?.delete[modalObj?.languageObj?.id],
                    enabledDelete: true,
                    showEdit: true,
                    labelEdit: labels?.edit?.[modalObj?.languageObj?.id],
                    enabledEdit: true,
                    processButtons: processButtons,
                })?.result,
            ])?.draw(true);
            //#endregion datatable add

            response.msgText = `${messages?.processCompletedSuccessfully?.[modalObj?.languageObj?.id]}.`;
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, save: false }));

            if (response?.isSuccess && !response?.isWarning) {
                setDefaultValue({ closeModal: true, subMethod: currentMethod });
            }

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth: modalObj?.auth,
                    languageId: modalObj?.languageObj?.id,
                });
            }
        }
    }

    const editCustomer = async ({
        e = undefined,
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'editCustomer';
        try {
            e?.preventDefault?.();

            //#region errors default / validate data
            response = setErrorsDefault({
                subMethod: currentMethod,
            });
            if (!response?.isSuccess || response?.isWarning) return;

            response = validateFormData({
                subMethod: currentMethod,
            });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion errors default / validate data

            setProcess(prev => ({ ...prev, save: true }));

            //#region customer (update)
            response = await CustomerService.update({
                auth: modalObj?.auth,
                id: customer?.id,
                data: customer,
                languageId: modalObj?.languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;

            const updatedCustomer = Customer?.getClass(response?.result?.customer, false);
            //#endregion customer (update)

            //#region datatable update
            const processButtons = [];
            modalObj.$(`#${modalObj.dtCustomersId}`).DataTable().row(modalObj.dtCustomersRowId).data([
                updatedCustomer?.secundaryId,
                updatedCustomer?.name,
                updatedCustomer?.rif,
                updatedCustomer?.nit,
                badgetStatusGeneric({
                    type: updatedCustomer?.isAvailable ? 0 : 5,
                    value: updatedCustomer?.isAvailable ? labels?.yes?.[modalObj?.languageObj?.id] : labels?.no?.[modalObj?.languageObj?.id],
                }),
                getProcessButtons({
                    id: updatedCustomer?.id,
                    description: updatedCustomer?.name,
                    showDetails: true,
                    labelDetails: labels?.details[modalObj?.languageObj?.id],
                    enabledDetails: true,
                    showDelete: true,
                    labelDelete: labels?.delete[modalObj?.languageObj?.id],
                    enabledDelete: true,
                    showEdit: true,
                    labelEdit: labels?.edit?.[modalObj?.languageObj?.id],
                    enabledEdit: true,
                    processButtons: processButtons,
                })?.result,
            ])?.draw(true);
            //#endregion datatable update

            response.msgText = `${messages?.processCompletedSuccessfully?.[modalObj?.languageObj?.id]}.`;
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, save: false }));

            if (response?.isSuccess && !response?.isWarning) {
                setDefaultValue({ closeModal: true, subMethod: currentMethod });
            }

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth: modalObj?.auth,
                    languageId: modalObj?.languageObj?.id,
                });
            }
        }
    }
    //#endregion customer

    //#region others
    const getData = async ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'getData';
        try {
            //#region is available
            modalObj.$(`#${controls?.checkBox?.isAvailable.id}`).attr('checked', customer?.isAvailable);
            //#endregion is available
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({ response, currentMethod, auth: modalObj?.auth, languageId: modalObj?.languageObj?.id });
            }
        }
    }

    const setDefaultValue = ({
        closeModal = false,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setDefaultValue';
        let response = getResponse({ type: 0 });
        try {
            if (closeModal) {
                setModalObj(prev => ({
                    ...prev,
                    showModal: false,
                    type: 0,
                }));
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console.error(response?.msgText);
        }
    }

    const validateFormData = ({
        subMethod = ''
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'validateFormData';
        try {
            if (isUndNullEmp({ data: customer, subMethod: currentMethod })?.result) {
                setErrors(prev => ({
                    ...prev,
                    secondaryId: `${messages?.thisFieldRequired?.[modalObj?.languageObj?.id]}.`,
                    name: `${messages?.thisFieldRequired?.[modalObj?.languageObj?.id]}.`,
                }));
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: customer?.secundaryId, subMethod: currentMethod })?.result) {
                setErrors(prev => ({ ...prev, secondaryId: `${messages?.thisFieldRequired?.[modalObj?.languageObj?.id]}.` }));
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: customer?.name, subMethod: currentMethod })?.result) {
                setErrors(prev => ({ ...prev, name: `${messages?.thisFieldRequired?.[modalObj?.languageObj?.id]}.` }));
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: customer?.rif, subMethod: currentMethod })?.result) {
                setErrors(prev => ({ ...prev, rif: `${messages?.thisFieldRequired?.[modalObj?.languageObj?.id]}.` }));
                response.isWarning = true;
            }

            if (!isUndNullEmp({ data: customer?.phones, subMethod: currentMethod })?.result && !isValidPhoneNumber({ data: customer?.phones })) {
                setErrors(prev => ({ ...prev, phones: `${messages?.youMustEnterValidPhoneNumber[modalObj?.languageObj?.id]}.` }));
                response.isWarning = true;
            }

            if (!isUndNullEmp({ data: customer?.fax, subMethod: currentMethod })?.result && !isValidPhoneNumber({ data: customer?.fax })) {
                setErrors(prev => ({ ...prev, fax: `${messages?.youMustEnterValidPhoneNumber[modalObj?.languageObj?.id]}.` }));
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: customer?.address, subMethod: currentMethod })?.result) {
                setErrors(prev => ({ ...prev, address: `${messages?.thisFieldRequired?.[modalObj?.languageObj?.id]}.` }));
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: customer?.email, subMethod: currentMethod })?.result) {
                setErrors(prev => ({ ...prev, email: `${messages?.thisFieldRequired?.[modalObj?.languageObj?.id]}.` }));
                response.isWarning = true;
            } else if (!isUndNullEmp({ data: customer?.email, subMethod: currentMethod })?.result && !isValidEmail({ data: customer?.email })) {
                setErrors(prev => ({ ...prev, email: `${messages?.youMustEnterValidEmail[modalObj?.languageObj?.id]}.` }));
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: customer?.webSite, subMethod: currentMethod })?.result) {
                setErrors(prev => ({ ...prev, webSite: `${messages?.thisFieldRequired?.[modalObj?.languageObj?.id]}.` }));
                response.isWarning = true;
            } else if (!isUndNullEmp({ data: customer?.webSite, subMethod: currentMethod })?.result && !isValidUrl({ data: customer?.webSite })?.result) {
                setErrors(prev => ({ ...prev, webSite: `${messages?.youMustEnterValidUrl[modalObj?.languageObj?.id]}.` }));
                response.isWarning = true;
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            // Helper v2.2: Silent
        }
        return response;
    }

    const setErrorsDefault = ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'setErrorsDefault';
        try {
            setErrors({
                secondaryId: '',
                name: '',
                rif: '',
                nit: '',
                phones: '',
                fax: '',
                address: '',
                email: '',
                webSite: '',
            });
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    useEffect(() => {
        isMount.current = true;
        getData({ subMethod: 'onLoadForm' });
        return () => {
            isMount.current = false;
        }
    }, []);// eslint-disable-line react-hooks/exhaustive-deps
    //#endregion others
    //#endregion methods

    return (
        <Modal backdrop='static' show={modalObj?.showModal} centered size=''>
            <Modal.Header className='border-bottom-0 pt-4 px-4 bg-white'>
                <Modal.Title className='d-flex align-items-center w-100'>
                    <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                        style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <img alt='customer' src={images?.icons?.customers} style={{ ...styles?.cardHeaderLogo }}></img>
                    </div>
                    <div className='d-flex flex-column'>
                        <h5 className='h5 mb-0 font-weight-bold text-dark'>{labels?.customer?.[modalObj?.languageObj?.id]}</h5>
                        <div className='d-flex align-items-center mt-1'>
                            <span className={`badge badge-pill px-2 py-1 text-uppercase ${modalObj?.type === 0 ? 'badge-info' : modalObj?.type === 1 ? 'badge-warning text-dark' : 'badge-secondary'}`}
                                style={settings?.html?.badges?.micro}>
                                {modalObj?.type === 0 ?
                                    labels?.add?.[modalObj?.languageObj?.id] :
                                    modalObj?.type === 1 ?
                                        labels?.edit?.[modalObj?.languageObj?.id] :
                                        labels?.detail?.[modalObj?.languageObj?.id]}
                            </span>
                        </div>
                    </div>
                </Modal.Title>
                <button id={controls?.buttons?.closeModal?.id}
                    type='button'
                    className='close border-0 bg-transparent'
                    data-dismiss='modal'
                    aria-label='Close'
                    disabled={process?.save}
                    style={{ fontSize: '1.5rem', marginTop: '-15px' }}
                    onClick={() => setDefaultValue({ closeModal: true, subMethod: controls?.buttons?.closeModal?.id })}>
                    <span aria-hidden='true'>&times;</span>
                </button>
            </Modal.Header >
            <Modal.Body className='p-0'>
                <form onSubmit={(e) => e.preventDefault()}>
                    <div className='card-body p-4'>
                        {modalObj?.type !== 2 ?
                            <div>
                                <div className='form-group'>
                                    <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                        <i className={icons?.indentFasFa} /> {labels?.code[modalObj?.languageObj?.id]}
                                    </small>
                                    <input autoFocus
                                        id={controls?.inputs?.secondaryId.id}
                                        className='form-control bg-light border-0 shadow-sm'
                                        readOnly={process?.save}
                                        maxLength={dataFormLength?.max?.secundaryId}
                                        onChange={(e) => setCustomer(prev => ({ ...prev, secundaryId: e?.target?.value }))}
                                        onFocus={() => setErrors(prev => ({ ...prev, secondaryId: '' }))}
                                        value={!isUndNullEmp({ data: customer, subMethod: controls?.inputs?.secondaryId.id, })?.result && !isUndNullEmp({ data: customer?.secundaryId, subMethod: controls?.inputs?.secondaryId.id, })?.result ?
                                            customer?.secundaryId : ''}
                                        placeholder={labels?.code[modalObj?.languageObj?.id]}
                                        title={labels?.code[modalObj?.languageObj?.id]} />
                                    <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.secondaryId)}</div>
                                </div>

                                <div className='form-group'>
                                    <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                        <i className={icons?.fasFa?.spellCheck} /> {labels?.description?.[modalObj?.languageObj?.id]}
                                    </small>
                                    <input id={controls?.inputs?.name?.id}
                                        className='form-control bg-light border-0 shadow-sm'
                                        readOnly={process?.save}
                                        maxLength={dataFormLength?.max?.name}
                                        onChange={(e) => setCustomer(prev => ({ ...prev, name: e?.target?.value }))}
                                        onFocus={() => setErrors(prev => ({ ...prev, name: '' }))}
                                        value={!isUndNullEmp({ data: customer, subMethod: controls?.inputs?.name?.id, })?.result && !isUndNullEmp({ data: customer?.name, subMethod: controls?.inputs?.name?.id, })?.result ?
                                            customer?.name : ''}
                                        placeholder={labels?.description?.[modalObj?.languageObj?.id]}
                                        title={labels?.description?.[modalObj?.languageObj?.id]} />
                                    <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.name)}</div>
                                </div>

                                <div className='row'>
                                    <div className='col-md-6'>
                                        <div className='form-group'>
                                            <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                <i className={icons?.fasFa?.spellCheck} /> {labels?.rif?.[modalObj?.languageObj?.id]}
                                            </small>
                                            <input id={controls?.inputs?.rif.id}
                                                className='form-control bg-light border-0 shadow-sm'
                                                readOnly={process?.save}
                                                maxLength={dataFormLength?.max?.rif}
                                                onChange={(e) => setCustomer(prev => ({ ...prev, rif: e?.target?.value }))}
                                                onFocus={() => setErrors(prev => ({ ...prev, rif: '' }))}
                                                value={!isUndNullEmp({ data: customer, subMethod: controls?.inputs?.rif.id, })?.result && !isUndNullEmp({ data: customer?.rif, subMethod: controls?.inputs?.rif.id, })?.result ?
                                                    customer?.rif : ''}
                                                placeholder={labels?.rif?.[modalObj?.languageObj?.id]}
                                                title={labels?.rif?.[modalObj?.languageObj?.id]} />
                                            <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.rif)}</div>
                                        </div>
                                    </div>
                                    <div className='col-md-6'>
                                        <div className='form-group'>
                                            <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                <i className={icons?.fasFa?.spellCheck} /> {labels?.nit[modalObj?.languageObj?.id]}
                                            </small>
                                            <input id={controls?.inputs?.nit.id}
                                                className='form-control bg-light border-0 shadow-sm'
                                                readOnly={process?.save}
                                                maxLength={dataFormLength?.max?.nit}
                                                onChange={(e) => setCustomer(prev => ({ ...prev, nit: e?.target?.value }))}
                                                onFocus={() => setErrors(prev => ({ ...prev, nit: '' }))}
                                                value={!isUndNullEmp({ data: customer, subMethod: controls?.inputs?.nit.id, })?.result && !isUndNullEmp({ data: customer?.nit, subMethod: controls?.inputs?.nit.id, })?.result ?
                                                    customer?.nit : ''}
                                                placeholder={labels?.nit[modalObj?.languageObj?.id]}
                                                title={labels?.nit[modalObj?.languageObj?.id]} />
                                            <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.nit)}</div>
                                        </div>
                                    </div>
                                </div>

                                <div className='row'>
                                    <div className='col-md-6'>
                                        <div className='form-group'>
                                            <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                <i className={icons?.mobileAlt} /> {labels?.phones?.[modalObj?.languageObj?.id]}
                                            </small>
                                            <input id={controls?.inputs?.phones?.id}
                                                className='form-control bg-light border-0 shadow-sm'
                                                readOnly={process?.save}
                                                maxLength={dataFormLength?.max?.phones}
                                                onChange={(e) => setCustomer(prev => ({ ...prev, phones: e?.target?.value }))}
                                                onFocus={() => setErrors(prev => ({ ...prev, phones: '' }))}
                                                value={!isUndNullEmp({ data: customer, subMethod: controls?.inputs?.phones?.id, })?.result && !isUndNullEmp({ data: customer?.phones, subMethod: controls?.inputs?.phones?.id, })?.result ?
                                                    customer?.phones : ''}
                                                placeholder={labels?.phones?.[modalObj?.languageObj?.id]}
                                                title={labels?.phones?.[modalObj?.languageObj?.id]} />
                                            <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.phones)}</div>
                                        </div>
                                    </div>
                                    <div className='col-md-6'>
                                        <div className='form-group'>
                                            <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                <i className={icons?.fax} /> {labels?.fax[modalObj?.languageObj?.id]}
                                            </small>
                                            <input id={controls?.inputs?.fax.id}
                                                className='form-control bg-light border-0 shadow-sm'
                                                readOnly={process?.save}
                                                maxLength={dataFormLength?.max?.fax}
                                                onChange={(e) => setCustomer(prev => ({ ...prev, fax: e?.target?.value }))}
                                                onFocus={() => setErrors(prev => ({ ...prev, fax: '' }))}
                                                value={!isUndNullEmp({ data: customer, subMethod: controls?.inputs?.fax.id, })?.result && !isUndNullEmp({ data: customer?.fax, subMethod: controls?.inputs?.fax.id, })?.result ?
                                                    customer?.fax : ''}
                                                placeholder={labels?.fax[modalObj?.languageObj?.id]}
                                                title={labels?.fax[modalObj?.languageObj?.id]} />
                                            <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.fax)}</div>
                                        </div>
                                    </div>
                                </div>

                                <div className='form-group'>
                                    <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                        <i className={icons?.mapMarkedAlt} /> {labels?.address[modalObj?.languageObj?.id]}
                                    </small>
                                    <textarea id={controls.textAreas.address.id}
                                        className='form-control bg-light border-0 shadow-sm'
                                        readOnly={process?.save}
                                        maxLength={dataFormLength?.max?.address}
                                        onChange={(e) => setCustomer(prev => ({ ...prev, address: e?.target?.value }))}
                                        onFocus={() => setErrors(prev => ({ ...prev, address: '' }))}
                                        placeholder={labels?.address[modalObj?.languageObj?.id]}
                                        rows={2}
                                        tooltip='tooltip'
                                        title={labels?.address[modalObj?.languageObj?.id]}
                                        value={!isUndNullEmp({ data: customer, subMethod: '' })?.result && !isUndNullEmp({ data: customer?.address })?.result ? `${customer?.address}` : ``}>
                                    </textarea>
                                    <div className='form-text' style={styles?.labelMsgAlert}>{parse(errors?.address)}</div>
                                </div>

                                <div className='row'>
                                    <div className='col-md-6'>
                                        <div className='form-group'>
                                            <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                <i className={icons?.envelope} /> {labels?.email?.[modalObj?.languageObj?.id]}
                                            </small>
                                            <input id={controls?.inputs?.email?.id}
                                                className='form-control bg-light border-0 shadow-sm'
                                                readOnly={process?.save}
                                                maxLength={dataFormLength?.max?.email}
                                                onChange={(e) => setCustomer(prev => ({ ...prev, email: e?.target?.value }))}
                                                onFocus={() => setErrors(prev => ({ ...prev, email: '' }))}
                                                value={!isUndNullEmp({ data: customer, subMethod: controls?.inputs?.email?.id, })?.result && !isUndNullEmp({ data: customer?.email, subMethod: controls?.inputs?.email?.id, })?.result ?
                                                    customer?.email : ''}
                                                placeholder={labels?.email?.[modalObj?.languageObj?.id]}
                                                title={labels?.email?.[modalObj?.languageObj?.id]} />
                                            <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.email)}</div>
                                        </div>
                                    </div>
                                    <div className='col-md-6'>
                                        <div className='form-group'>
                                            <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                <i className={icons?.globe} /> {labels?.webSite[modalObj?.languageObj?.id]}
                                            </small>
                                            <input id={controls?.inputs?.webSite.id}
                                                className='form-control bg-light border-0 shadow-sm'
                                                readOnly={process?.save}
                                                maxLength={dataFormLength?.max?.webSite}
                                                onChange={(e) => setCustomer(prev => ({ ...prev, webSite: e?.target?.value }))}
                                                onFocus={() => setErrors(prev => ({ ...prev, webSite: '' }))}
                                                value={!isUndNullEmp({ data: customer, subMethod: controls?.inputs?.webSite.id, })?.result && !isUndNullEmp({ data: customer?.webSite, subMethod: controls?.inputs?.webSite.id, })?.result ?
                                                    customer?.webSite : ''}
                                                placeholder={labels?.webSite[modalObj?.languageObj?.id]}
                                                title={labels?.webSite[modalObj?.languageObj?.id]} />
                                            <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.webSite)}</div>
                                        </div>
                                    </div>
                                </div>

                                <div className='row'>
                                    <div className='col-md-6'>
                                        <div className='form-group'>
                                            <small className='text-muted text-uppercase font-weight-bold d-block mb-3'>
                                                <i className={icons?.fasFa?.toggleOn} /> {labels?.isActive?.[modalObj?.languageObj?.id] || 'IS AVAILABLE'}
                                            </small>
                                            <input id={controls?.checkBox?.isAvailable.id}
                                                type='checkbox'
                                                className='shadow-sm'
                                                style={{ cursor: (process?.save || modalObj?.type === 2) ? 'default' : 'pointer' }}
                                                data-toggle='toggle'
                                                data-size='sm'
                                                data-width={75}
                                                data-onstyle='primary'
                                                data-on={labels?.yes?.[modalObj?.languageObj?.id] || 'YES'}
                                                data-off={labels?.no?.[modalObj?.languageObj?.id] || 'NO'}
                                                disabled={process?.save}
                                                onClick={(e) => setCustomer(prev => ({ ...prev, isAvailable: e?.target?.checked, }))}
                                                onChange={(e) => setCustomer(prev => ({ ...prev, isAvailable: e?.target?.checked, }))} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                            <div className='row'>
                                {/* Details View Premium */}
                                <div className='col-md-12 mb-4'>
                                    <div className='p-3 rounded bg-light border-left border-primary shadow-sm h-100' style={{ borderLeftWidth: '5px' }}>
                                        <small className='text-muted text-uppercase font-weight-bold d-block mb-1' style={settings?.html?.labels?.detailMicro}>
                                            <i className={icons?.fasFa?.spellCheck} /> {labels?.description?.[modalObj?.languageObj?.id]}
                                        </small>
                                        <div className='h5 mb-0 font-weight-bold text-dark' style={{ wordBreak: 'break-word', whiteSpace: 'pre-wrap' }}>{customer?.name || '---'}</div>
                                    </div>
                                </div>

                                <div className='col-md-6 mb-3'>
                                    <div className='p-3 rounded bg-light border-left border-info shadow-sm h-100' style={{ borderLeftWidth: '5px' }}>
                                        <small className='text-muted text-uppercase font-weight-bold d-block mb-1' style={settings?.html?.labels?.detailMicro}>
                                            <i className={icons?.indentFasFa} /> {labels?.code?.[modalObj?.languageObj?.id]}
                                        </small>
                                        <div className='h6 mb-0 font-weight-bold text-secondary' style={{ wordBreak: 'break-word' }}>{customer?.secundaryId || '---'}</div>
                                    </div>
                                </div>

                                <div className='col-md-6 mb-3'>
                                    <div className='p-3 rounded bg-light border-left border-secondary shadow-sm h-100' style={{ borderLeftWidth: '5px' }}>
                                        <small className='text-muted text-uppercase font-weight-bold d-block mb-1' style={settings?.html?.labels?.detailMicro}>
                                            <i className={icons?.fasFa?.spellCheck} /> {labels?.rif?.[modalObj?.languageObj?.id]}
                                        </small>
                                        <div className='h6 mb-0 font-weight-bold' style={{ wordBreak: 'break-word' }}>{customer?.rif || '---'}</div>
                                    </div>
                                </div>

                                <div className='col-md-6 mb-3'>
                                    <div className='p-3 rounded bg-light border-left border-secondary shadow-sm h-100' style={{ borderLeftWidth: '5px' }}>
                                        <small className='text-muted text-uppercase font-weight-bold d-block mb-1' style={settings?.html?.labels?.detailMicro}>
                                            <i className={icons?.fasFa?.spellCheck} /> {labels?.nit?.[modalObj?.languageObj?.id]}
                                        </small>
                                        <div className='h6 mb-0 font-weight-bold' style={{ wordBreak: 'break-word' }}>{customer?.nit || '---'}</div>
                                    </div>
                                </div>

                                <div className='col-md-6 mb-3'>
                                    <div className='p-3 rounded bg-light border-left border-success shadow-sm h-100' style={{ borderLeftWidth: '5px' }}>
                                        <small className='text-muted text-uppercase font-weight-bold d-block mb-1' style={{ fontSize: '0.7rem', letterSpacing: '0.5px' }}>
                                            <i className={icons?.mobileAlt} /> {labels?.phones?.[modalObj?.languageObj?.id]}
                                        </small>
                                        <div className='h6 mb-0 font-weight-bold text-dark' style={{ wordBreak: 'break-word' }}>{customer?.phones || '---'}</div>
                                    </div>
                                </div>

                                <div className='col-md-6 mb-3'>
                                    <div className='p-3 rounded bg-light border-left border-success shadow-sm h-100' style={{ borderLeftWidth: '5px' }}>
                                        <small className='text-muted text-uppercase font-weight-bold d-block mb-1' style={{ fontSize: '0.7rem', letterSpacing: '0.5px' }}>
                                            <i className={icons?.fax} /> {labels?.fax?.[modalObj?.languageObj?.id]}
                                        </small>
                                        <div className='h6 mb-0 font-weight-bold text-dark' style={{ wordBreak: 'break-word' }}>{customer?.fax || '---'}</div>
                                    </div>
                                </div>

                                <div className='col-md-6 mb-3'>
                                    <div className='p-3 rounded bg-light border-left border-primary shadow-sm h-100' style={{ borderLeftWidth: '5px' }}>
                                        <small className='text-muted text-uppercase font-weight-bold d-block mb-1' style={{ fontSize: '0.7rem', letterSpacing: '0.5px' }}>
                                            <i className={icons?.envelope} /> {labels?.email?.[modalObj?.languageObj?.id]}
                                        </small>
                                        <div className='h6 mb-0 font-weight-bold' style={{ wordBreak: 'break-word' }}>
                                            {customer?.email ? <a href={`mailto:${customer?.email}`} className='text-primary'>{customer?.email}</a> : '---'}
                                        </div>
                                    </div>
                                </div>

                                <div className='col-md-6 mb-3'>
                                    <div className='p-3 rounded bg-light border-left border-info shadow-sm h-100' style={{ borderLeftWidth: '5px' }}>
                                        <small className='text-muted text-uppercase font-weight-bold d-block mb-1' style={{ fontSize: '0.7rem', letterSpacing: '0.5px' }}>
                                            <i className={icons?.globe} /> {labels?.webSite?.[modalObj?.languageObj?.id]}
                                        </small>
                                        <div className='h6 mb-0 font-weight-bold' style={{ wordBreak: 'break-word' }}>
                                            {customer?.webSite ? <a href={checkUrl({ data: customer?.webSite, subMethod: '' })?.result} target='_blank' rel='noreferrer' className='text-primary'>{customer?.webSite}</a> : '---'}
                                        </div>
                                    </div>
                                </div>

                                <div className='col-md-6 mb-3'>
                                    <div className='p-3 rounded bg-light border-left border-primary shadow-sm h-100' style={{ borderLeftWidth: '5px' }}>
                                        <small className='text-muted text-uppercase font-weight-bold d-block mb-1' style={settings?.html?.labels?.detailMicro}>
                                            <i className={icons?.fasFa?.list} /> {labels?.enabled?.[modalObj?.languageObj?.id]}
                                        </small>
                                        <div className='h6 mb-0'>
                                            {parse(badgetStatusGeneric({
                                                type: customer?.isAvailable ? 0 : 5,
                                                value: customer?.isAvailable ? labels?.yes?.[modalObj?.languageObj?.id] : labels?.no?.[modalObj?.languageObj?.id]
                                            }))}
                                        </div>
                                    </div>
                                </div>

                                <div className='col-md-12 mt-2'>
                                    <small className='text-muted text-uppercase font-weight-bold d-block mb-2' style={settings?.html?.labels?.detailMicro}>
                                        <i className={icons?.mapMarkedAlt} /> {labels?.address?.[modalObj?.languageObj?.id]}
                                    </small>
                                    <div className='p-3 rounded bg-white border shadow-sm' style={{ minHeight: '80px', fontSize: '0.95rem', lineHeight: '1.6', wordBreak: 'break-word', whiteSpace: 'pre-wrap' }}>
                                        {customer?.address || '---'}
                                    </div>
                                </div>
                            </div>
                        }

                    </div>
                </form>
            </Modal.Body>
            <Modal.Footer className='border-top-0 pb-4 px-4 bg-white justify-content-center'>
                <div className='d-flex justify-content-center w-100'>
                    <button id={controls?.buttons?.save?.id}
                        className='btn btn-primary px-4 mr-3 shadow-sm font-weight-bold'
                        style={{ borderRadius: '5px' }}
                        disabled={process?.save}
                        hidden={modalObj?.type === 2}
                        onClick={(e) => modalObj?.type === 0 ? addCustomer({ e: e }) : editCustomer({ e: e })}
                        tooltip='tooltip'
                        title={modalObj?.type === 0 ? labels?.add?.[modalObj?.languageObj?.id] : labels?.save?.[modalObj?.languageObj?.id]}
                        type='button'>
                        {process?.save ? (
                            <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                        ) : (
                            <i id={controls?.icons?.save?.id} className={controls?.icons?.save?.defaultClass} />
                        )} {modalObj?.type === 0 ? labels?.add?.[modalObj?.languageObj?.id] : labels?.save?.[modalObj?.languageObj?.id]}
                    </button>
                    <button id={controls?.buttons?.back?.id}
                        className='btn btn-outline-secondary px-4 shadow-sm font-weight-bold'
                        style={{ borderRadius: '5px' }}
                        disabled={process?.save}
                        tooltip='tooltip'
                        title={labels?.close?.[modalObj?.languageObj?.id]}
                        type='button'
                        onClick={() => setDefaultValue({ closeModal: true, subMethod: controls?.buttons?.back?.id })}>
                        <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.defaultClass}></i> {labels?.back?.[modalObj?.languageObj?.id]}
                    </button>
                </div>
            </Modal.Footer>
        </Modal >
    )
}